import { render, staticRenderFns } from "./WalletUsdtQuote.vue?vue&type=template&id=00ddf0ee&"
import script from "./WalletUsdtQuote.vue?vue&type=script&lang=js&"
export * from "./WalletUsdtQuote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports